// A document's timeline, whether or not the version index governs it.
//
// A file uploaded straight into Genba carries no recorded history, but it
// still has exactly one version — itself. Synthesising that entry here keeps
// the drawer's timeline and the table's row menu reading the same shape, so a
// version-level affordance (markup) doesn't have to know which kind of
// document it is looking at.

import type { IDocument, IDocumentVersion } from '@apis/documents';

/** Newest first, like the listing's own `versions`. */
export function documentVersions(doc: IDocument): IDocumentVersion[] {
  if (doc.versions.length > 0) return doc.versions;
  // A standalone file has no approval state of its own — it predates the
  // index — so it carries no actions.
  return [{
    version: doc.version, description: doc.description, author: doc.updatedBy,
    date: doc.updatedAt, fileId: doc.id, sizeBytes: doc.sizeBytes, status: doc.status,
    canSubmit: false, canApprove: false, canReject: false, canDelete: false,
  }];
}

/** The version a document presents — what a document-level action opens. */
export function headlineVersionOf(doc: IDocument): IDocumentVersion | undefined {
  const versions = documentVersions(doc);
  return versions.find((v) => v.version === doc.version) ?? versions[0];
}
